export default __webpack_public_path__ + "static/media/arrow-right-orange.779cbd9b.svg";